// extracted by mini-css-extract-plugin
module.exports = {"pdf-viewer":"classes_pdf-viewer__7HMZj","no-pdf-text":"classes_no-pdf-text__MS1sA","pdf-fallback-link":"classes_pdf-fallback-link__PvkDw"};